var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.disabled ? 'disabled' : _vm.show_only ? '' : 'enabled',on:{"click":function($event){return _vm.$emit('click-block', _vm.block)}}},[_c('MeldedBlock',{attrs:{"block":_vm.block,"seat":0}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }